import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    modal: {
      '& .MuiDialog-paper': {
        width: '474px',
        maxWidth: '100%',
      },
    },
    infoText: {
      fontSize: 16,
      lineHeight: '22px',
      color: STYLE.COLOR.TEXT1,
    },
    receivePinText: {
      fontSize: 16,
      lineHeight: '22px',
      color: STYLE.COLOR.TEXT1,
      marginTop: '12px',
    },
    contactMethodText: {
      color: `${STYLE.COLOR.TEXT2} !important`,
      marginTop: '12px',
    },
    otpInput: {
      marginTop: '22px',
      marginBottom: '12px',
      '@media (max-width: 768px)': {
        '& input': {
          fontSize: '22px !important',
        },
      },
      '@media (max-width: 500px)': {
        '& input': {
          fontSize: '20px !important',
        },
        '& .MuiBox-root': {
          gap: '12px !important',
        },
      },
    },
    resentPinParent: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    resendPinButton: {
      padding: '0px !important',
      height: 'auto !important',
      textDecoration: 'underline !important',
    },
    yesButton: {
      minWidth: '122px !important',
    },
    verifyButton: {
      minWidth: '138px !important',
    },
  }),
);
